<div class="container-fluid">
    <h3>Retención Reportería</h3>
    <h4>Ingresa los parámetros de búsqueda.</h4>
        <div class="inciativaform">
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="exampleFormControlSelect1">Estado</label>
                        <select class="form-control" [(ngModel)]="estadoIniciativa" name="plazo">
                            <option value="Activo">Activo</option>
                            <option value="Inactivo">Inactivo</option>
                        </select>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="exampleFormControlSelect1">Fecha inicio de registro</label>
                    <input class="form-control form-rounded" type="date"
                    [min]="beginLimitDate"
                    [max]="maxDate"
                    [(ngModel)]="beginDate">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label for="exampleFormControlSelect1">Fecha final de registro</label>
                    <input class="form-control form-rounded" type="date"
                    [(ngModel)]="endDate"
                    [min]="beginLimitDate"
                    [max]="maxDate">
                    </div>
                </div>
            </div>
        </div>
</div>
